<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="anliyixiabox">
      <div class="anliyixialeft">
        <div class="anliyixiatopbox">
          <dl class="anlitopbtndl">
            <dt>
              <img :src="anlifbicon" />
            </dt>
            <dd>发布安利</dd>
          </dl>

          <dl class="anlitopnrdl">
            <dt>“ 安利美好事物 ”</dt>
            <dd>这个世界很美好，值得我们为它奋斗 ——《战地钟声》</dd>
          </dl>
        </div>

        <div class="anliyixialeftbox">
          <div class="anliyixialist" @click="gotoanliyixiadetails">
            <dl>
              <dd>
                <img :src="anliyxpic" />
              </dd>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist" @click="gotoanliyixiadetails">
            <dl>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist" @click="gotoanliyixiadetails">
            <dl>
              <dd>
                <img :src="anliyxpic" />
              </dd>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist">
            <dl>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist">
            <dl>
              <dd>
                <img :src="anliyxpic" />
              </dd>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist">
            <dl>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist">
            <dl>
              <dd>
                <img :src="anliyxpic" />
              </dd>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>

          <div class="anliyixialist">
            <dl>
              <dt>
                <h3>安利只能选十部电影，你应该会喜欢！</h3>
                <h5>安利菌：@你蛋掉了</h5>
                <div class="anliyxnrbox">
                  <p>1.《肖申克的救赎》 信念“有一种鸟儿是永远也关不住的，因为它的每片羽翼上都沾满了自由的光辉”一个人能够在15年痛苦的牢狱生活里，不放弃对自由的向往，这是一种怎样的精神力量？所以....</p>
                </div>

                <div class="anliyxplbox">
                  <ul>
                    <li>
                      <img :src="anliyxicon01" />
                      <span>255 赞</span>
                    </li>
                    <li>
                      <img :src="anliyxicon02" />
                      <span>50 踩</span>
                    </li>
                    <li>
                      <img :src="anliyxicon03" />
                      <span>200 快评</span>
                    </li>
                  </ul>
                </div>
              </dt>
            </dl>
          </div>
        </div>
      </div>
      <div class="anliyixiaright">
        <Affix :offset-top="-30">
          <div
            class="zxxqanli"
            :style="{ 'background': 'url(' + zxxqanlibg + ') no-repeat center center', 'background-size': '100% 100%'}"
          >
            <div class="zxxqanlitop">
              <dl>
                <dd>
                  <img :src="zxxqanlisx" />
                </dd>
                <dt @click="gotoyiwan">最新寻求安利</dt>
              </dl>
            </div>
            <div class="zxxqanlilistbox" @click="gotoyiwan">
              <Timeline>
                <TimelineItem color="#ffa200">
                  <p class="time">@Boss 12分钟</p>
                  <p
                    class="content"
                  >前段时间无聊刷手机看看朋友圈,跟我看她的一模一样，想不通为啥子一模一样，想不通为啥子一模一样，想不通为啥子一模一样，想不通为啥子一模一样，想不通为啥子</p>
                </TimelineItem>
                <TimelineItem color="#ffa200">
                  <p class="time">@tree</p>
                  <p class="content">谁知道小米电视怎么样有用过的给安利一下</p>
                </TimelineItem>
                <TimelineItem color="#ffa200">
                  <p class="time">@周同学</p>
                  <p class="content">谁知道哪里用什么工具可以看到火星</p>
                </TimelineItem>
                <TimelineItem color="#ffa200">
                  <p class="time">@青青</p>
                  <p class="content">哪里可以听到周杰伦的免费歌呢</p>
                </TimelineItem>
                <TimelineItem color="#ffa200">
                  <p class="time">@苹果的</p>
                  <p class="content">苹果手机哪款比较好玩，感觉我的6p很卡想要换一下</p>
                </TimelineItem>
              </Timeline>
            </div>

            <div class="morexqal" @click="gotoyiwan">
              <span>查看更多</span>
            </div>
          </div>

          <div class="qiuanlibox">
            <div class="qiuanlitopbox">
              <dl>
                <dt>
                  <img :src="qiuanlitop" />
                </dt>
                <dd>求安利，求推荐，SOS,或者想说点什么...</dd>
              </dl>
            </div>
            <div class="qiuanlimainbox">
              <ul>
                <li>
                  <dl>
                    <dt>昵称：</dt>
                    <dd>
                      <Input v-model="formItem.username" placeholder="请输入昵称"></Input>
                    </dd>
                  </dl>
                </li>
                <li>
                  <dl>
                    <dt>邮箱：</dt>
                    <dd>
                      <Input v-model="formItem.email" placeholder="请输入邮箱"></Input>
                    </dd>
                  </dl>
                </li>
                <li>
                  <Input
                    v-model="formItem.textarea"
                    class="textarea"
                    type="textarea"
                    :autosize="{minRows: 3,maxRows: 8}"
                    placeholder="请输入求安利，求推荐，SOS具体内容..."
                  ></Input>
                </li>
                <li>
                  <span>确定发布</span>
                </li>
              </ul>
            </div>
          </div>
        </Affix>
      </div>
    </div>

    <div class="footerbox"></div>

    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
export default {
  components: { addweb },
  data() {
    return {
      anlifbicon: require("@/assets/images/fbicon.png"),
      anliyxpic: require("@/assets/images/anliyxpic.jpg"),
      anliyxicon01: require("@/assets/images/anliyxicon001.gif"),
      anliyxicon02: require("@/assets/images/anliyxicon002.gif"),
      anliyxicon03: require("@/assets/images/anliyxicon003.gif"),
      zxxqanlibg: require("@/assets/images/zxalibox.gif"),
      zxxqanlisx: require("@/assets/images/shuaxianicon.gif"),
      qiuanlitop: require("@/assets/images/qaltoppic.gif"),
      nid: "1",
      formItem: {
        username: "",
        email: "",
        textarea: ""
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {},
  methods: {
    gotolabeldetails() {
      this.$router.push({
        name: "labeldetails"
      });
    },
    gotoyiwan() {
      let { href } = this.$router.resolve({ name: "yiwan",query:{
        id:5
      } });
      window.open(href, "_blank");
    },
    gotoanliyixiadetails(){
      let { href } = this.$router.resolve({ name: "anliyixiadetails",query:{
        id:5
      } });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding-top: 60px;
}
html,
body {
  height: 100%;
}

.anliyixiabox {
  width: 1300px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
  .anliyixialeft {
    width: 950px;
    margin-left: 5px;
    float: left;
    padding-top: 20px;
    padding-bottom: 50px;
    .anliyixiatopbox {
      width: 940px;
      height: 130px;
      background: #f7f7f7;
      .anlitopbtndl {
        float: right;
        width: 197px;
        height: 50px;
        border: 1px solid #ffa200;
        background: #fff;
        border-radius: 30px;
        margin-top: 46px;
        margin-right: 25px;
        dt {
          float: left;
          padding-left: 46px;
          padding-top: 12px;
        }
        dd {
          float: left;
          font-size: 18px;
          padding-top: 10px;
          color: #ffa200;
          padding-left: 10px;
        }
      }
      .anlitopnrdl {
        float: left;
        dt {
          font-size: 26px;
          padding-left: 20px;
          color: #434343;
          font-weight: bold;
          padding-top: 30px;
        }
        dd {
          font-size: 14px;
          color: #999;
          padding-left: 53px;
          padding-top: 10px;
        }
      }
    }

    .anliyixialeftbox {
      .anliyixialist {
        background: #fff;
        margin-top: 20px;
        width: 940px;
        box-shadow: 0 0 5px #ddd;
        height: 193px;
        dl {
          padding: 23px 28px 28px 28px;
          dd {
            float: right;
            padding-left: 30px;
            padding-top: 5px;
          }
          dt {
            h3 { cursor: pointer;
              font-size: 20px;
            }
            h5 {
              font-size: 14px;
              padding-top: 3px;
              color: #999;
              font-weight: normal;
            }
          }
          .anliyxnrbox {cursor: pointer;
            padding-top: 10px;
            height: 55px;
            overflow: hidden;
            p {
              font-size: 14px;
            }
          }

          ul {
            padding-top: 18px;
            li {
              float: left;cursor: pointer;
              padding-right: 20px;
              img {
                float: left;
                margin-top: 1px;
              }
              span {
                float: left;
                color: #666;
                padding-left: 10px;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
  .anliyixiaright {
    width: 343px;
    float: left;
    .zxxqanli {
      width: 324px;
      height: 541px;
      float: right;
      overflow: hidden;
      margin-top: 22px;
      .zxxqanlitop {
        dl {
          dt {
            color: #fff;
            padding-left: 20px;
            padding-top: 32px;
            font-size: 15px;
            cursor: pointer;
          }
          dd {
            float: right;
            padding-right: 30px;
            padding-top: 1px;
          }
        }
      }
      .zxxqanlilistbox {
        margin-left: 20px;
        cursor: pointer;
        padding-top: 20px;
        height: 375px;
        overflow: hidden;
        clear: both;
        padding-right: 25px;
        .time {
          color: #999;
          padding: 0;
          line-height: 18px;
          padding-bottom: 5px;
        }
        .content {
          color: #333;
        }
      }

      .morexqal {
        padding-top: 30px;
        padding-left: 20px;
        padding-right: 20px;
        span {
          border: 1px solid #ffa200;
          text-align: center;
          cursor: pointer;
          display: block;
          color: #ffa200;
          line-height: 36px;
          font-size: 15px;
        }
      }
    }

    .qiuanlibox {
      border: 1px solid #e1e1e1; background: #fff;
      width: 323px;
      clear: both;
      margin-top: 20px;
      float: right;
      padding-bottom: 10px;
      .qiuanlitopbox {
        dl {
          dt {
            text-align: center;
          }
          dd {
            text-align: center;
            font-weight: bold;
            font-size: 15px;
            padding-top: 10px;
          }
        }
      }

      .qiuanlimainbox {
        clear: both;
        padding-top: 20px;
        ul {
          clear: both;
          padding-left: 10px;
          li {
            clear: both;
            padding-left: 15px;
            width: 292px;
            padding-bottom: 10px;
            >>> .ivu-input:hover {
              border-color: #ffa200;
            }
            >>> .ivu-input:focus {
              border-color: #ffa200;
            }
            dl {
              overflow: hidden;
              dt {
                float: left;
                font-size: 13px;
                padding-top: 6px;
              }
              dd {
                float: right;
                width: 230px;
              }
            }
            .textarea textarea {
              height: 60px;
            }
            span {
              display: block;
              text-align: center;
              border: 1px solid #e1e1e1;
              line-height: 35px;
              background: #f8f8f8;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.footerbox {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/anliyixia.vue